import {
  CloseOutlined,
  DownloadOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { Button, Card, Form, Input, Modal, Switch, Typography } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import {
  createRDStationIntegration,
  deleteRDStationIntegration,
  getRDStationIntegration,
  updateRDStationIntegration,
} from '../../services/rd-station-integration'

import { toast } from 'sonner'
export function RDStationIntegration({ icon, label, assistantID }) {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const [buttonLoading, setButtonLoading] = useState(false)
  const [configOpen, setConfigOpen] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    setLoading(true)
    getRDStationIntegration(assistantID)
      .then(({ data }) => {
        if (data.length === 0) return
        setData(data[0])
      })
      .catch((error) => {
        console.log(error)
        toast.error('Erro ao buscar integração com RD Station.')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [assistantID])

  const install = useCallback(
    (values) => {
      setButtonLoading(true)
      createRDStationIntegration(parseInt(assistantID), {
        isActive: true,
        ...values,
      })
        .then(({ data }) => {
          setData(data)
          setConfigOpen(false)
        })
        .catch((error) => {
          console.log(error)
          toast.error('Erro ao instalar integração com Rd Station.')
        })
        .finally(() => {
          setButtonLoading(false)
          form.resetFields()
        })
    },
    [assistantID]
  )

  const uninstall = useCallback(() => {
    setButtonLoading(true)
    deleteRDStationIntegration(assistantID, data.id)
      .then(() => {
        setData(undefined)
      })
      .catch((error) => {
        console.log(error)
        toast.error('Erro ao remover integração com RD Station.')
      })
      .finally(() => {
        setButtonLoading(false)
      })
  }, [data])

  const update = useCallback(
    (newData) => {
      setButtonLoading(true)
      updateRDStationIntegration(assistantID, data.id, newData)
        .then(({ data: updatedData }) => {
          setData({ ...updatedData })
          setConfigOpen(false)
          toast.success('Atualizado com sucesso!')
        })
        .catch((error) => {
          console.log(error)
          toast.error('Erro ao atualizar.')
        })
        .finally(() => {
          setButtonLoading(false)
          form.resetFields()
        })
    },
    [data]
  )

  const finishForm = useCallback(
    (values) => {
      if (!data) return install(values)

      update(values)
    },
    [data]
  )

  useEffect(() => {
    form.setFieldsValue(data)
  }, [data, form])

  return (
    <>
      <Modal
        title="Configurar RDStation"
        open={configOpen}
        cancelText={'Cancelar'}
        confirmLoading={buttonLoading}
        okText={'Salvar'}
        onOk={form.submit}
        onCancel={() => setConfigOpen(false)}
      >
        <br />

        <Form layout={'vertical'} form={form} onFinish={finishForm}>
          <Form.Item
            label={'Token'}
            help={
              <>
                <a
                  href={'https://crm.rdstation.com/app#/settings/profile'}
                  target={'_blank'}
                  rel="noreferrer"
                >
                  Clique aqui
                </a>{' '}
                para gerar seu token
              </>
            }
            name={'token'}
          >
            <Input.Password
              placeholder={'ID da instancia do RD Station'}
              autocomplete="off"
            />
          </Form.Item>

          <Form.Item
            label={'Criar pessoa automaticamente'}
            name={'autoCreateContact'}
            valuePropName={'checked'}
            help={'Cria a pessoa de forma automática na primeira mensagem'}
            initialValue={false}
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label={'Criar negócio automaticamente'}
            name={'autoCreateDeal'}
            valuePropName={'checked'}
            help={'Cria o negócio de forma automática na primeira mensagem'}
            initialValue={false}
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label={'Integração Ativa'}
            name={'isActive'}
            valuePropName={'checked'}
            help={'Ativa/Desativa integração'}
            initialValue={true}
          >
            <Switch />
          </Form.Item>
        </Form>
      </Modal>
      <Card
        loading={loading}
        title={
          <Typography.Title level={5} ellipsis={{ tooltip: label }}>
            {icon} {label}
          </Typography.Title>
        }
        extra={
          <Button
            type={data ? 'default' : 'primary'}
            loading={loading || buttonLoading}
            danger={!!data}
            onClick={() => (data ? uninstall() : setConfigOpen(true))}
            icon={data ? <CloseOutlined /> : <DownloadOutlined />}
          >
            {loading ? undefined : data ? 'Remover' : 'Instalar'}
          </Button>
        }
        actions={
          data
            ? [<SettingOutlined onClick={() => setConfigOpen(true)} />]
            : undefined
        }
      >
        <Typography>
          Configure o whatsapp com sua instancia do{' '}
          <a
            target={'_blank'}
            rel="noreferrer"
            href={'https://crm.rdstation.com/'}
          >
            RD Station
          </a>
          .
        </Typography>
      </Card>
    </>
  )
}
